import { createGlobalStyle, css } from "styled-components";

const palette = {
  white: "#fff",
  red: "#d90117",
  blue: {
    darker: "#17457A",
    dark: "#004C9B",
    medium: "#0D67B3",
    light: "#00A3E0",
    lighter: "#EEF1F5",
    lightest: "#F3FBFE",
  },
  grey: {
    darkest: "#262626",
    darker: "#383838",
    dark: "#707070",
    medium: "#8D8C8C",
    light: "#e0e0e0",
    ultraLight: "#f0f0f0",
    lightest: "#f7f7f7",
  },
  darker: "rgba(0,0,0,0.1)",
};

const textSize = {
  mobileLarge: "1.5rem",
  mobileMedium: "1.5rem",
  mobileSmall: "1.3rem",
  desktopLarge: "3rem",
  desktopMedium: "2rem",
  desktopSmall: "1.6rem",
};

const breakPoints = {
  small: 450,
  medium: 640,
  large: 1024,
};

const theme = {
  resFontSize: {
    large: css`
      font-size: ${textSize.mobileLarge};
      @media screen and (min-width: ${breakPoints.medium}px) {
        font-size: ${textSize.desktopLarge};
      }
    `,

    medium: css`
      font-size: ${textSize.mobileMedium};
      @media screen and (min-width: ${breakPoints.medium}px) {
        font-size: ${textSize.desktopMedium};
      }
    `,

    small: css`
      font-size: ${textSize.mobileSmall};
      @media screen and (min-width: ${breakPoints.medium}px) {
        font-size: ${textSize.desktopSmall};
      }
    `,
  },
  fontSize: textSize,
  palette: {
    ...palette,
    primary: palette.blue.dark,
    secondary: palette.blue.light,
    accent: palette.red,
    background: {
      grey: palette.blue.lighter,
      azure: palette.blue.lightest,
    },
    outlineColor: `rgba(0, 76, 155, 0.3)`,
  },
  radius: {
    small: 9,
    large: 20,
  },
  spacer: 10,
  breakPoints,
  mediaQueries: {
    small: `@media screen and (min-width: ${breakPoints.small}px)`,
    medium: `@media screen and (min-width: ${breakPoints.medium}px)`,
    large: `@media screen and (min-width: ${breakPoints.large}px)`,
  },
  page: {
    maxWidth: 1200,
    screenColor: palette.grey.light,
    bgColor: palette.white,
  },
  shadow: "0 2px 10px 3px rgba(0, 0, 0, 0.2)",
};

export default theme;

export const Typography = createGlobalStyle`    
  @page{
    margin-top:50px;
    margin-bottom:50px;
      :first {
        margin-top:0px;
      }
  }
  html {
    scroll-behavior: smooth;
  }
  body {
    font-family: "EMprint", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    ${theme.resFontSize.small};
    background-color: ${theme.page.screenColor};
    line-height: 1.3;
    @media print {
      background-color: transparent;      
    }
  }

  h1 {
    ${theme.resFontSize.large};
    font-weight: bold;
    margin: 0 0 .5em;
  }

  h2 {
    ${theme.resFontSize.medium};
    color:${theme.palette.primary};
    font-weight: bold;
    margin: 0 0 .5em;
  }

  h3 {
    ${theme.resFontSize.small};
    font-weight: normal;
    margin: 0 0 .5sem;
  }

  #root{
    height:1px;
    min-height: 100%;
  }

  input{
    border: none;
    padding:${theme.spacer}px ${theme.spacer * 2}px;
    font-size: inherit;
  }

  p{
    margin-top:0;
  }
  a{
    color:${palette.blue.dark};
    cursor:pointer;
    display: inline-block;
    text-decoration:none;
    outline: none;
    &:focus, &:hover{
      text-decoration:underline;
    }
  }
  button {
    border: none;
    padding: 0;
    cursor: pointer;
    outline: none;
    &:focus{
      box-shadow: 0 0 1px 2px ${theme.palette.outlineColor};
    }
  }

  .ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media print {
    button,
    .react-sanfona-item .labelWrapper{
      break-inside: avoid;
      display: block;
    }
  }
`;
